import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useGetSoilSensorParameter } from '../../hooks/useGetSoilSensorParameter';
import { generateSmartTicks } from '../../helpers/graphsUtils';

const GraficaSoilHumidityCB = ({ soilSensorId, start, end }) => {

  const { observations, loading } = useGetSoilSensorParameter({
    soilSensorId,
    start,
    end,
    parameter: "soilHumidityCB"
  });

  const formattedObservations = observations.map((observation) => ({
    ...observation,
    timestamp: new Date(observation.timestamp).getTime()
  }));

  const xTicks =
    formattedObservations.length > 0
      ? generateSmartTicks(
          formattedObservations[0].timestamp,
          formattedObservations[formattedObservations.length - 1].timestamp
        )
      : [];

  return (
    <div>
      <h3>💧 Humedad del Suelo (cB)</h3>

      {loading ? (
        <p>Cargando observaciones...</p>
      ) : formattedObservations?.length > 0 ? (
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '28px',
          padding: '10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          marginTop: '10px'
        }}>
        <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={formattedObservations}
          margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            dataKey="timestamp"
            scale="time"
            type="number"
            domain={['auto', 'auto']}
            angle={-45}
            textAnchor="end"
            height={60}
            ticks={xTicks}
            tick={{ fontSize: 14 }}
            tickFormatter={(time) => {
              const date = new Date(time);
              return date.toLocaleTimeString([], {
                day: '2-digit',
                month: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hourCycle: 'h23'
              });
            }}
          />

          <YAxis label={{ value: 'cB', angle: -90, position: 'insideLeft' }} />

          <Tooltip
            cursor={false}
            content={({ active, payload, label }) => {
              if (active && payload && payload.length) {
                const date = new Date(label).toLocaleString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  hourCycle: 'h23'
                });

                const valor =
                  payload.find((p) => p.dataKey === 'soilHumidityCB')?.value ?? null;

                return (
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '10px',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                      color: '#333'
                    }}
                  >
                    <p><strong>{date}</strong></p>
                    {valor !== null && <p>💧 {valor} cB</p>}
                  </div>
                );
              }
              return null;
            }}
          />

          <Legend verticalAlign="top" height={36} align="right" />

          <Line
            type="monotone"
            dataKey="soilHumidityCB"
            name="Humedad del Suelo (cB)"
            stroke="#1a7abf"
            dot={false}
          />
        </LineChart>
        </ResponsiveContainer>
        </div>
      ) : (
        <p>No hay datos disponibles para este sensor</p>
      )}
    </div>
  );
};

export default GraficaSoilHumidityCB;
